"use client";

import { BSRImageLandscape } from "./bsr/BSRImageLandscape";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { ImageLandscape as LegacyImageLandscape } from "./legacy/ImageLandscape";

export const ImageLandscape = createBSRExperimentIcon(
  LegacyImageLandscape,
  BSRImageLandscape
);
